import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationSidebarComponent } from './navigation-sidebar/navigation-sidebar.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LandingComponent } from './landing/landing.component';
import { PricingComponent } from './pricing/pricing.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { FilterComponent } from './filter/filter.component';
import { RequestLogsComponent } from './request-logs/request-logs.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { RegisterComponent } from './register/register.component';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { NewPropertyComponent } from './new-property/new-property.component';
import { UpdatePropertyComponent } from './update-property/update-property.component';
import { WebsitePreviewComponent } from './website-preview/website-preview.component';
import { TemplateRowComponent } from './template-row/template-row.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { TemplateEditorComponent } from './template-editor/template-editor.component';
import { PreviewPageComponent } from './preview-page/preview-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeaturesComponent } from './features/features.component';
import { WhychooseusComponent } from './whychooseus/whychooseus.component';
import { NewsComponent } from './news/news.component';
import { SupportComponent } from './support/support.component';
import { UrlPipe } from './url.pipe';
import { MobileNavbarComponent } from './mobile-navbar/mobile-navbar.component';
import { WarmUpComponent } from './warm-up/warm-up.component';
import { CreatedPropertyComponent } from './created-property/created-property.component';
import { LocationStrategy, HashLocationStrategy} from '@angular/common';
import { GetStartedComponent } from './get-started/get-started.component';
import { TrackingComponent } from './tracking/tracking.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { UserProfileComponent } from './user-profile/user-profile.component';
import { FirstTimeSetupComponent } from './first-time-setup/first-time-setup.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationSidebarComponent,
    DashboardPageComponent,
    LoginComponent,
    PageNotFoundComponent,
    LandingComponent,
    PricingComponent,
    OnboardingComponent,
    FilterComponent,
    RequestLogsComponent,
    ConfigurationComponent,
    RegisterComponent,
    NewPropertyComponent,
    UpdatePropertyComponent,
    WebsitePreviewComponent,
    TemplateRowComponent,
    TemplateEditorComponent,
    PreviewPageComponent,
    FeaturesComponent,
    WhychooseusComponent,
    NewsComponent,
    SupportComponent,
    UrlPipe,
    MobileNavbarComponent,
    WarmUpComponent,
    CreatedPropertyComponent,
    GetStartedComponent,
    TrackingComponent,
    UserProfileComponent,
    FirstTimeSetupComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    FroalaEditorModule.forRoot(), 
    FroalaViewModule.forRoot(),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    GooglePlaceModule
    
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
